export const URL = "https://postgresql.phalanxservices.com";
// note
